export function groupBy<T, K extends string | number | symbol>(
	array: T[],
	key: ((item: T) => K) | keyof T,
): Record<K, T[]> {
	return array.reduce((acc, item) => {
		const groupKey =
			typeof key === 'function' ? key(item) : (item[key] as unknown as K);

		if (!acc[groupKey]) {
			acc[groupKey] = [];
		}

		acc[groupKey].push(item);
		return acc;
	}, {} as Record<K, T[]>);
}
